import React, { useState, useEffect } from "react";
import { makeApiRequest } from "../axiosService/apiCall";
import { ToastContainer, toast } from "react-toastify";
import { useFormik } from "formik";
import * as yup from "yup";
// import { useState } from "react";

function Adminmanual() {
    const [isLoading, setIsLoading] = useState(false);
    const [admindata, setAdmindata] = useState([]);

    // console.log('admindata', admindata)

    useEffect(() => {
        Adminhistory();
    }, [])

    const formik = useFormik({
        initialValues: {
            email: "",
            coin: "",
        },
        validationSchema: yup.object().shape({
            email: yup.string().email("Invalid Email").required("Enter User Email"),
            coin: yup
                .number()
                .typeError("Enter a valid number") // Ensures input is a number
                .required("Enter The Coins") // Required field
                .positive("Amount must be positive") // Optional: Ensures positive numbers only
        }),
        onSubmit: async (values) => {
            setIsLoading(true)
            try {
                const formData = new FormData();
                formData.append("email", values.email);
                formData.append("coin", values.coin);

                let params = {
                    url: "sendcointouser",
                    method: "POST",
                    data: formData,
                };

                const response = await makeApiRequest(params);


                if (response.status === true) {
                    setIsLoading(false)
                    Adminhistory();
                    toast.success(response.message);
                    formik.resetForm();

                } else {
                    setIsLoading(false)
                    Adminhistory();
                    toast.warning(response.message);
                }
            }
            catch (err) {
                // console.log(err);
            }
        },
    });
    const Adminhistory = async () => {
        try {
            let params = {
                url: `getadmindata`,
                method: 'GET',
            };
            let response = await makeApiRequest(params);
            // console.log(response,"response");

            if (response.status === true) {
                setAdmindata(response.findAdminHis);

            } else {
                setAdmindata([]);
            }
        } catch (error) {
            // console.log('error', error);
        }
    };


    return (
        <div className="App">
            <div className="container-fluid">
                <div className="custom-saled-order text-dark ms-3">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="py-3 d-flex justify-content-between">
                                <h3 className="component-user text-center ms-lg-0">Admin Manual Coin Update</h3>
                                <h3 className="component-user text-center ms-lg-0">WalletBalance :{admindata?.adminWalletAmount ? admindata.adminWalletAmount.toFixed(3) : "0.000"}
                                    Texa</h3>

                            </div>
                            <div className="row">
                                <div className="col-lg-6">
                                    <div className="site-admin-add-1">
                                        <form onSubmit={formik.handleSubmit}>
                                            <div className="mb-3">
                                                <label htmlFor="email" className="form-label">Email address</label>
                                                <input
                                                    type="text"
                                                    className="form-control custom-input-1"
                                                    id="email"
                                                    value={formik.values.email}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                />
                                                {formik.errors.email && formik.touched.email && (
                                                    <div style={{ color: "red" }}>{formik.errors.email}</div>
                                                )}
                                            </div>
                                            <div className="mb-3">
                                                <label htmlFor="coin" className="form-label">Amount</label>
                                                <input
                                                    type="text"
                                                    className="form-control custom-input-1"
                                                    id="coin"
                                                    value={formik.values.coin}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                />
                                                {formik.errors.coin && formik.touched.coin && (
                                                    <div style={{ color: "red" }}>{formik.errors.coin}</div>
                                                )}
                                            </div>
                                            <div className="text-center">
                                                <button type="submit" className="register-btn-spinner-1" disabled={isLoading} // Disable when loading
                                                > {isLoading ? "Processing..." : "SUBMIT"}</button>
                                            </div>
                                        </form>
                                        <ToastContainer />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Adminmanual;
